import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { order, getTypePrefix  } from '@/api'

/**
 * 获取订单详细信息
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderDetailAction = createAsyncThunk(
    getTypePrefix(order.getEshopOrderInfoByCodeUrl),
    async (params) => await okHttp(order.getEshopOrderInfoByCodeUrl, {
        method: 'GET',
	    params
    })
)

/**
 * 获取物流信息
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getShippingInfoDetailAction = createAsyncThunk(
    getTypePrefix(order.getShippingInfoDetailUrl),
    async (params) => await okHttp(order.getShippingInfoDetailUrl, {
        method: 'GET',
        params
    })
)

/**
 * 创建仅退款订单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const createOnlyRefundAction = createAsyncThunk(
    getTypePrefix(order.createOnlyRefund),
    async (data) => await okHttp(order.createOnlyRefund, {
        method: 'POST',
	    data
    })
)

/**
 * 创建退货退款订单
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const createReturnGoodsForRefundAction = createAsyncThunk(
    getTypePrefix(order.createReturnGoodsForRefund),
    async (data) => await okHttp(order.createReturnGoodsForRefund, {
        method: 'POST',
        data
    })
)

/**
 * 新增订单备注
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const addOrderRemarkAction = createAsyncThunk(
    getTypePrefix(order.addOrderRemark),
    async (data) => await okHttp(order.addOrderRemark, {
        method: 'POST',
        data
    })
)
